import { MainApi } from 'api/MainApi'
import type { GausiumExecutableTaskRecent } from 'api/RobotApi'
import type { IScenarioInfo } from 'components/SharedScenarioItem/SharedScenarioItem'

export function gausiumExecTaskToScenarioInfo(
  t: GausiumExecutableTaskRecent,
  previewUrl?: string | null
): IScenarioInfo {
  const mapLabel = (t.map_name || '—').trim()
  const sn = (t.robot_sn || '').trim()
  return {
    id: t.id,
    name: (t.task_name || '(no task name)').trim(),
    missions_ids: [mapLabel],
    missions_count: 1,
    missions_statuses: ['ok'],
    robot_type: sn,
    is_gausium_executable_task: true,
    gausium_robot_id: t.robot_id,
    gausium_map_pk: t.gausium_map_id ?? null,
    gausium_exec_task: t,
    preview_url: previewUrl ?? null,
  }
}

export async function enrichGausiumExecTasksWithMapPreviews(
  tasks: GausiumExecutableTaskRecent[]
): Promise<IScenarioInfo[]> {
  const pks = Array.from(new Set(tasks.map(t => t.gausium_map_id).filter((x): x is number => x != null && x > 0)))
  const previews = new Map<number, string | null>()
  await Promise.all(
    pks.map(async pk => {
      try {
        const res = await MainApi.fetchGausiumMaps(undefined, undefined, undefined, undefined, pk)
        const url = res.results?.[0]?.preview_url ?? null
        previews.set(pk, url)
      } catch {
        previews.set(pk, null)
      }
    })
  )
  return tasks.map(t =>
    gausiumExecTaskToScenarioInfo(t, t.gausium_map_id != null ? previews.get(t.gausium_map_id) ?? null : null)
  )
}
